import React from 'react';
import { IconFlag } from '@hawkins/assets';
import { Popover, Box, Text, Toggle, Heading } from '@hawkins/components';
import useFeatureFlag from '../../hooks/useFeatureFlag';
import { isTest } from '../../hooks/useEnvironment';
import { Dimensions } from '@hawkins/variables';
import { Grid } from '../Grid';

/**
 * Component that displays a popover with a toggle for feature flags in test environments only
 */
export const FeatureFlagToggle: React.FC = () => {
  const { multipleFramingDecisionsEnabled, toggleMultipleFramingDecisions } =
    useFeatureFlag();
  const isTestEnv = isTest();

  // Only render in test environment
  if (!isTestEnv) {
    return null;
  }

  return (
    <Popover interactive>
      <Popover.Trigger>
        <IconFlag />
      </Popover.Trigger>
      <Popover.Content>
        <Grid
          gap={Dimensions.Space16}
          padding={Dimensions.Space16}
          width="300px"
        >
          <Heading level={0}>Feature Flags</Heading>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Text level={1}>Multiple Framing Decisions</Text>
            <Toggle
              checked={multipleFramingDecisionsEnabled}
              onChange={toggleMultipleFramingDecisions}
              aria-label="Toggle Multiple Framing Decisions"
            />
          </Box>
          <Text color="textSecondary">
            Note: Feature flags are only toggleable in the test environments
          </Text>
        </Grid>
      </Popover.Content>
    </Popover>
  );
};

export default FeatureFlagToggle;
